import React, { useState } from "react";
import { useForm } from "../../hooks/useForm";
import moment from "moment";
import { Calendario } from "../Otros/Calendario";
import { useFetch } from "../../hooks/useFetch";
import "react-datepicker/dist/react-datepicker.css";
import { UrlWs } from "../../utils/Global";

export const InformacionProcesoParticipacion = ({ proceso }) => {
  console.log(proceso);

  const [formData, handleInputChange, reset, updateValue] = useForm({
    yearProcess: proceso.yearProcess,
    name: proceso.name,
    fecha1Start: moment(
      proceso.qualificationStages[0].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha1End: moment(
      proceso.qualificationStages[0].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha2Start: moment(
      proceso.qualificationStages[1].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha2End: moment(
      proceso.qualificationStages[1].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha3Start: moment(
      proceso.qualificationStages[2].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha3End: moment(
      proceso.qualificationStages[2].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha4Start: moment(
      proceso.qualificationStages[3].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha4End: moment(
      proceso.qualificationStages[3].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
  });

  const {
    yearProcess,
    name,
    fecha1Start,
    fecha1End,
    fecha2Start,
    fecha2End,
    fecha3Start,
    fecha3End,
    fecha4Start,
    fecha4End,
  } = formData;

  const [actualizarProceso, setActualizarProceso] = useState(false);
  const [datosProceso, setDatosProceso] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [error, setError] = useState("");

  var InFecha1text = "";
  var InFecha2text = "";
  var InFecha3text = "";

  var InFecha1class = "";
  var InFecha2class = "";
  var InFecha3class = "";

  var InFecha1input = "";
  var InFecha2input = "";
  var InFecha3input = "";

  function InFecha1() {
    var ahora = moment();
    if (
      ahora.isBetween(
        moment(proceso.qualificationStages[0].starDate),
        moment(proceso.qualificationStages[0].endDate)
      )
    ) {
      // 'dentroProceso'; form-label mt-4
      InFecha1text = "Periodo Activo";
      InFecha1class = "form-label mt-4 text-success";
      InFecha1input = "form-control mb-5 is-valid";
    } else {
      if (moment(proceso.qualificationStages[0].starDate) > ahora) {
        // 'noIniciado';
        InFecha1text = "No iniciado";
        InFecha1class = "form-label mt-4";
        InFecha1input = "form-control mb-5";
      }
      if (moment(proceso.qualificationStages[0].endDate) < ahora) {
        // 'terminado';
        InFecha1text = "Terminado";
        InFecha1class = "form-label mt-4 text-danger";
        InFecha1input = "form-control mb-5 is-invalid";
      }
    }
  }

  function InFecha2() {
    var ahora = moment();
    if (
      ahora.isBetween(
        moment(proceso.qualificationStages[1].starDate),
        moment(proceso.qualificationStages[1].endDate)
      )
    ) {
      // 'dentroProceso';
      InFecha2text = "Periodo Activo";
      InFecha2class = "form-label mt-4 text-success";
      InFecha2input = "form-control mb-5 is-valid";
    } else {
      if (moment(proceso.qualificationStages[1].starDate) > ahora) {
        // 'noIniciado';
        InFecha2text = "No iniciado";
        InFecha2class = "form-label mt-4";
        InFecha2input = "form-control mb-5";
      }
      if (moment(proceso.qualificationStages[1].endDate) < ahora) {
        // 'terminado';
        InFecha2text = "Terminado";
        InFecha2class = "form-label mt-4 text-danger";
        InFecha2input = "form-control mb-5 is-invalid";
      }
    }
  }

  function InFecha3() {
    var ahora = moment();
    if (
      ahora.isBetween(
        moment(proceso.qualificationStages[2].starDate),
        moment(proceso.qualificationStages[2].endDate)
      )
    ) {
      // 'dentroProceso';
      InFecha3text = "Periodo Activo";
      InFecha3class = "form-label mt-4 text-success";
      InFecha3input = "form-control mb-5 is-valid";
    } else {
      if (moment(proceso.qualificationStages[2].starDate) > ahora) {
        // 'noIniciado';
        InFecha3text = "No iniciado";
        InFecha3class = "form-label mt-4";
        InFecha3input = "form-control mb-5";
      }
      if (moment(proceso.qualificationStages[2].endDate) < ahora) {
        // 'terminado';
        InFecha3text = "Terminado";
        InFecha3class = "form-label mt-4 text-danger";
        InFecha3input = "form-control mb-5 is-invalid";
      }
    }
  }
  InFecha1();
  InFecha2();
  InFecha3();

  const CalendarioFecha1Start = () => {
    return (
      <Calendario
        value={fecha1Start}
        name="fecha1Start"
        id="fecha1Start"
        key="fecha1Start"
        disabled="true"
        className={InFecha1input}
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha1End = () => {
    return (
      <Calendario
        value={fecha1End}
        name="fecha1End"
        id="fecha1End"
        key="fecha1End"
        disabled="true"
        className={InFecha1input}
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha2Start = () => {
    return (
      <Calendario
        value={fecha2Start}
        name="fecha2Start"
        id="fecha2Start"
        key="fecha2Start"
        disabled="true"
        className={InFecha2input}
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha2End = () => {
    return (
      <Calendario
        value={fecha2End}
        name="fecha2End"
        id="fecha2End"
        key="fecha2End"
        disabled="true"
        className={InFecha2input}
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha3Start = () => {
    return (
      <Calendario
        value={fecha3Start}
        name="fecha3Start"
        id="fecha3Start"
        key="fecha3Start"
        disabled="true"
        className={InFecha3input}
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha3End = () => {
    return (
      <Calendario
        value={fecha3End}
        name="fecha3End"
        id="fecha3End"
        key="fecha3End"
        disabled="true"
        className={InFecha3input}
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha4Start = () => {
    return (
      <Calendario
        value={fecha4Start}
        name="fecha4Start"
        id="fecha4Start"
        key="fecha4Start"
        disabled="true"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha4End = () => {
    return (
      <Calendario
        value={fecha4End}
        name="fecha4End"
        id="fecha4End"
        key="fecha4End"
        disabled="true"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  return (
    <>
      <div className="col-lg-12 col-sm-12">
        <form data-kt-search-element="advanced-options-form" className="pt-1">
          <div className="row">
            {cargandoDatos ? (
              <div className="col-12">
                <h4>Actualizando datos...</h4>
              </div>
            ) : (
              <>
                <div className="col-lg-4 col-sm-12">
                  <input
                    disabled="disabled"
                    type="text"
                    className="form-control mb-5"
                    placeholder="nombre proceso"
                    name="yearProcess"
                    value={yearProcess}
                  />
                </div>
                <div className="col-lg-8 col-sm-12">
                  <input
                    disabled="disabled"
                    type="text"
                    className="form-control mb-5"
                    placeholder="nombre proceso"
                    name="name"
                    value={name}
                  />
                </div>

                <div className="col-lg-12 col-sm-12">
                  <div className="row">
                    <div className="col-4">
                      <label className={InFecha1class}>
                        Evaluación Cuatrimestral (Periodo septiembre a diciembre):
                      </label>
                    </div>
                    <div className="col-5">
                      <div className="row">
                        <div className="col-lg-6 col-sm-12">
                          <CalendarioFecha1Start />
                        </div>
                        <div className="col-lg-6 col-sm-12">
                          <CalendarioFecha1End />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <label className={InFecha1class}>{InFecha1text}</label>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-sm-12">
                  <div className="row">
                    <div className="col-4">
                      <label className={InFecha2class}>
                      Evaluación Cuatrimestral (Periodo enero a abril):
                      </label>
                    </div>
                    <div className="col-5">
                      <div className="row">
                        <div className="col-lg-6 col-sm-12">
                          <CalendarioFecha2Start />
                        </div>
                        <div className="col-lg-6 col-sm-12">
                          <CalendarioFecha2End />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <label className={InFecha2class}>{InFecha2text}</label>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="row">
                    <div className="col-4">
                      <label className={InFecha3class}>
                      Precalificación (Periodo septiembre a agosto):
                      </label>
                    </div>
                    <div className="col-5">
                      <div className="row">
                        <div className="col-lg-6 col-sm-12">
                          <CalendarioFecha3Start />
                        </div>
                        <div className="col-lg-6 col-sm-12">
                          <CalendarioFecha3End />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <label className={InFecha3class}>{InFecha3text}</label>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </form>
      </div>
    </>
  );
};
